import client from '../client';
import * as portMutations from "../mutations/port";
import * as portsQueries from "../queries/port";

export function getPorts(success, error, force = false) {
    let fetchPolicy = 'cache-first';

    if (force === true) {
        fetchPolicy = 'network-only';
    }

    client.query({
        fetchPolicy: fetchPolicy,
        query: portsQueries.all,
    })
    .then(success)
    .catch(error);
}

export function edit(success, error, id, data) {
    client.mutate({
        variables: { id: id, port: data },
        mutation: portMutations.edit,
    })
        .then(success)
        .catch(error);
}

export function add(success, error, data) {
    client.mutate({
        variables: { port: data },
        mutation: portMutations.add,
    }).then(success).catch(error);
}


// WEBPACK FOOTER //
// ./src/graphql/actions/port.js